import { render, staticRenderFns } from "./veHqHaopinCrShow.vue?vue&type=template&id=1ba8bc20&scoped=true"
import script from "./veHqHaopinCrShow.vue?vue&type=script&lang=js"
export * from "./veHqHaopinCrShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba8bc20",
  null
  
)

export default component.exports